var OnboardingSteps;
(function (OnboardingSteps) {
    OnboardingSteps["SET_DETAILS"] = "step.set_details";
    OnboardingSteps["SET_PASSWORD"] = "step.set_password";
    OnboardingSteps["ACCEPT_GDPR"] = "step.accept_gdpr";
    OnboardingSteps["HAS_VIEWED_MEDICAL_ACTIVATION_PAGE"] = "step.hasViewedMedicalActivationPage";
    OnboardingSteps["HAS_HIDDEN_MEDICAL_ACTIVATION_PAGE"] = "step.hasHiddenMedicalActivationPageTooltip";
    OnboardingSteps["HAS_VIEWED_MEDICAL_GET_STARTED_PAGE"] = "step.hasViewedMedicalGetStartedPage";
    OnboardingSteps["HAS_HIDDEN_MEDICAL_GET_STARTED_PAGE"] = "step.hasHiddenMedicalGetStartedTooltip";
    OnboardingSteps["HAS_COMPLETED_HOMEPAGE_TOUR"] = "step.hasCompletedHomepageTour";
    OnboardingSteps["HAS_VIEWED_TENANT_SETUP_PRE_TOUR"] = "step.hasViewedTenantSetupPreTour";
    OnboardingSteps["HAS_COMPLETED_TENANT_SETUP_TOUR"] = "step.hasCompletedTenantSetupTour";
    OnboardingSteps["HAS_VIEWED_TENANT_SETUP_POST_TOUR"] = "step.hasViewedTenantSetupPostTour";
    OnboardingSteps["HAS_COMPLETED_RECOGNITION_WELCOME_TOUR"] = "step.recognition";
    OnboardingSteps["HAS_SEEN_APP_RATING_PROMPT"] = "step.hasSeenAppStoreRatingPrompt";
    OnboardingSteps["HAS_SEEN_PUSH_NOTIFICATION_PROMPT"] = "step.hasSeenPushNotificationPrompt";
    OnboardingSteps["HAS_COMPLETED_ADMIN_TOUR"] = "step.hasCompletedAdminTour";
    OnboardingSteps["HAS_DISMISSED_LINK_CARD_BANNER"] = "step.hasDismissedLinkCardBanner";
    OnboardingSteps["HAS_DISMISSED_CUSTOM_CATEGORIES_BANNER"] = "step.hasDismissedCustomCategoriesBanner";
})(OnboardingSteps || (OnboardingSteps = {}));
export default OnboardingSteps;
